var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header',{attrs:{"title":_vm.title,"hide-action":""}}),_c('div',{staticClass:"article-wrapper"},[_c('div',{staticClass:"article-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"article-content",domProps:{"innerHTML":_vm._s(_vm.body)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }